import React,{useEffect,useRef} from 'react';
export default function PollFeedback({value,visible}){
 const ref=useRef(null);
 useEffect(()=>{
  if(value?.state!=='error'||!visible||!value.locate)return;
  const el=ref.current,scroller=el?.closest('.translation-panel-scroll');if(!el||!scroller)return;
  const box=el.getBoundingClientRect(),view=scroller.getBoundingClientRect();
  if(box.top<view.top||box.bottom>view.bottom)el.scrollIntoView({block:'nearest',behavior:'instant'});
 },[value,visible]);
 if(!value)return null;
 return <p ref={ref} className={'poll-feedback '+(value.state==='error'?'is-error':value.state==='success'?'sr-only':'')} role={value.state==='error'?'alert':'status'}>{value.message}</p>;
}
